import {FaHome} from 'react-icons/fa';
import {useState} from 'react';
import {PropertyIssueModel} from './PropertyIssueModel';
import {issueAppearance} from './propertyIssueSummary';

export function PropertyIssue({job, onIssueSummaryChanged}) {
    const [show, setShow] = useState(false);
    const {color, title} = issueAppearance(job);
    const handleClose = event => {
        event?.stopPropagation();
        setShow(false);
    };

    return <>
        <FaHome style={{marginLeft: '10px', cursor: 'pointer', color}}
            size={22} title={title} aria-label={title}
            onClick={event => {event.stopPropagation(); setShow(true);}}/>
        {show ? <PropertyIssueModel show={show} job={job} handleClose={handleClose}
            onIssueSummaryChanged={onIssueSummaryChanged}/> : null}
    </>;
}
